<template>
  <div>
    <div class="text-center">
      <h2
        class="text-2xl tracking-wide leading-10 font-extrabold font-bebas text-peach mt-4 sm:text-5xl sm:leading-none md:text-4xl"
      >
        Behind the Vectric Curtains
      </h2>
      <div class="mt-6">
        <video controls class="w-full">
          <source
            src="https://firebasestorage.googleapis.com/v0/b/usergroupmeeting-a7f47.appspot.com/o/public%2FWorkshop_Tour_2B.mp4?alt=media&token=8e467a45-05f1-4106-b055-2191cb8e8dd3"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tour"
};
</script>

<style scoped></style>
